<template>
    <div class="users">
        <VHeader page="Admin Panel"></VHeader>
        <div class="users__page">
            <component
                :is="currentPage"
                :users="users"
                :user="user"
                :is-loading="isLoading"
                :is-loaded="isLoaded"
                :user-index="editedUserIndex"
                @editUser="editUser"
                @addNewUser="addNewUser"
                @deleteUser="showNotification"
                @applyChanges="applyChanges"
                @changePage="changePage"
                @showTooltip="showTooltip"
            />
        </div>
    </div>
</template>

<script>
    import AllUsers from './Users/AllUsers';
    import User from './Users/User';
    import {getEventsWithData, getFeatures, getProjectsWithData, getUser} from '../api/apiServices';
    import apiUsers from '../api/apiUsers';
    import {eventBus} from '../main';
    import {getUserTooltip} from './Users/UsersTooltips';
    import {getSavedRequestData} from '../helpers/testData';
    import {
      isTestBoardsMode,
    } from '@/api/apiServices';

    export default {
        name: 'Users',
        components: {
            AllUsers,
            User,
        },
        data() {
            return {
                isLoading: false,
                currentPage: AllUsers,
                editedUserIndex: 0,
                allEvents: {
                    isSelectedAll: false,
                    items: [],
                },
                allFeatures: {
                    isSelectedAll: false,
                    items: [],
                },
                allApps: {
                    isSelectedAll: false,
                    items: [],
                },
                user: {},
                users: [],
                newUser: {
                    id: null,
                    profilename: '',
                    email: '',
                    status: 'pending',
                    isEditable: true,
                    applications: {
                        items: [],
                        isSelectedAll: false,
                    },
                    features: {
                        items: [],
                        isSelectedAll: false,
                    },
                    events: {
                        items: [],
                        isSelectedAll: false,
                    },
                    filters: {
                        equal: null,
                    },
                },
                attributesWithOptions: ['geo', 'source'],
                isLoaded: false,
            };
        },
        created() {
            this.allEvents.items = this.prepareEventsForUser();
            this.allFeatures.items = this.prepareFeaturesForUser();
            this.allApps.items = this.prepareApplicationsForUser();
            this.getData();
            this.prepareNewUser();
            eventBus.$on('VNotification-DeleteUser', this.deleteUser);
        },
        beforeDestroy() {
            eventBus.$off('VNotification-DeleteUser', this.deleteUser);
        },
        methods: {
            showTooltip(event, name, data) {
                const tooltipData = getUserTooltip(name, data);
                this.$emit('showTooltip', event, tooltipData);
            },
            getData() {
                this.getUsers();
            },
            getUsers() {
                this.isLoading = true;
              if (!isTestBoardsMode()){
                apiUsers.getAllUsers().then((response) => {
                  try {
                    window.savedRequests.users = response.data;
                    this.users = this.mapUsers(response.data);
                    this.isLoading = false;
                    this.isLoaded = true;
                  } catch (e) {
                    console.log('e', e);
                  }
                }).catch((error) => {
                  this.isLoading = false;
                  this.$toastr.e(error.response.data.error);
                });
              }
              else{
                console.log(getSavedRequestData('users'))
                  this.users = this.mapUsers(getSavedRequestData('users'));
                  this.isLoading = false;
                  this.isLoaded = true;
              }
            },
            mapUsers(usersFromResponse) {
                const users = _.cloneDeep(usersFromResponse);
                users.forEach((user, userIndex) => {
                    user.isEditable = getUser().id !== user.id;
                    user.events = {
                        isSelectedAll: false,
                        items: this.prepareEventsForUser(),
                    };
                    user.features = {
                        isSelectedAll: true,
                        items: this.prepareFeaturesForUser(),
                    };
                    user.apps = {
                        isSelectedAll: false,
                        items: this.prepareApplicationsForUser(),
                    };
                    const userFromResponse = usersFromResponse[userIndex];
                    userFromResponse.events.forEach((eventName) => {
                        const event = user.events.items.find((event) => event.name === eventName);
                        if (event) {
                            event.isActive = true;
                        }
                    });
                    userFromResponse.features.forEach((attributeName) => {
                        try {
                            user.features.items.find((attribute) => attribute.name === attributeName).isActive = true;
                        } catch (e) {
                          this.$toastr.longError(`${attributeName} is absent in the list of attributes. User ${user.email}`);
                        }
                    });
                    userFromResponse.apps.forEach((applicationBundleId) => {
                        const app = user.apps.items.find((app) => app.bundle_id === applicationBundleId);
                        if (app) {
                            user.apps.items.find((app) => app.bundle_id === applicationBundleId).isActive = true;
                        }
                    });
                    
                    if (user.filters.equal) {
                        const userFeatures = Object.keys(user.filters.equal);
                        if (userFeatures.length) {
                            userFeatures.forEach((userFeature) => {
                                const featureWithOptions = user.features.items.find((feature) => feature.name === userFeature);
                                user.filters.equal[userFeature].forEach((featureOption) => {
                                    featureWithOptions.allOptions.push(featureOption);
                                    featureWithOptions.switcherOptions.All.isSelected = false;
                                    featureWithOptions.switcherOptions.Selected.isSelected = true;
                                });
                                featureWithOptions.isAttributeWithOptions = true;
                                featureWithOptions.isActive = true;
                            });
                        }
                    } else {
                        this.attributesWithOptions.forEach((option) => {
                            const featureWithOptions = user.features.items.find((feature) => feature.name ===
                                option.toLowerCase().trim());
                            featureWithOptions.isAttributeWithOptions = true;
                            featureWithOptions.isActive = true;
                        });
                    }
                });
                return users;
            },
            prepareEventsForUser() {
                const items = getEventsWithData();
                items.forEach((item) => {
                    item.isActive = false;
                });
                return items;
            },
            prepareFeaturesForUser() {
                const items = getFeatures().map((item) => {
                    const allOptions = [];
                    return {
                        name: item,
                        isActive: true,
                        isAttributeWithOptions: this.attributesWithOptions.includes(item.toLowerCase().trim()),
                        allOptions,
                        options: [],
                        isValid: true,
                        switcherOptions: {'All': {isSelected: true}, 'Selected': {isSelected: false}},
                    };
                });
                return items.sort((a, b) => a.allOptions.length - b.allOptions.length);
            },
            prepareApplicationsForUser() {
                const items = getProjectsWithData();
                items.forEach((item) => {
                    item.isActive = false;
                });
                return items;
            },
            prepareNewUser() {
                this.newUser.apps = _.cloneDeep(this.allApps);
                this.newUser.features = _.cloneDeep(this.allFeatures);
                this.newUser.events = _.cloneDeep(this.allEvents);
            },
            addNewUser() {
                this.user = _.cloneDeep(this.newUser);
                this.changePage(User);
            },
            editUser(user, userIndex) {
                this.user = _.cloneDeep(user);
                this.editedUserIndex = userIndex;
                this.changePage(User);
            },
            applyChanges(user, isEdit) {
                const userIndex = this.users.findIndex((u) => u.id === user.id);
                if (isEdit) {
                    this.updateUser(userIndex, user);
                } else {
                    this.sendInvitation(user);
                }
                this.changePage(AllUsers);
            },
            sendInvitation(user) {
                const sendObj = {
                    email: user.email,
                    profilename: user.profilename,
                    events: user.events.items.filter((item) => item.isActive).map((event) => event.name),
                    filters: user.filters,
                    apps: user.apps.items.filter((item) => item.isActive).map((application) => application.bundle_id),
                };
                return apiUsers.inviteUser(sendObj).then(() => {
                    this.users.push(user);
                    this.getUsers();
                    this.changePage(AllUsers);
                }).catch((error) => {
                    if (error.response.data.error) {
                        this.$toastr.longError(error.response.data.error);
                    } else {
                        this.$toastr.longError('Something went wrong');
                    }
                });
            },
            updateUser(userIndex, user) {
                const sendObj = {
                    events: user.events.items.filter((item) => item.isActive).map((event) => event.name),
                    features: user.features.items.filter((item) => item.isActive).map((attribute) => attribute.name),
                    filters: user.filters,
                    profilename: user.profilename,
                    apps: user.apps.items.filter((item) => item.isActive).map((application) => application.bundle_id),
                    block_dashboards: !!user.block_dashboards,
                };
                return apiUsers.updateUser(sendObj, user.id).then(() => {
                    this.users.splice(userIndex, 1, user);
                    this.changePage(AllUsers);
                }).catch(() => {
                    this.$toastr.e('Something went wrong');
                });
            },
            showNotification(user, profilename) {
                const userIndex = this.users.findIndex((u) => u.id === user.id);
                const notification = {};
                notification.confirmText = 'Delete';
                notification.data = userIndex;
                notification.eventConfirm = 'VNotification-DeleteUser';
                notification.contentText = 'This user will be deleted.';
                notification.headerText = `Delete user ${profilename}?`;
                eventBus.$emit('VNotificationShow', notification);
            },
            deleteUser(userIndex) {
                return apiUsers.deleteUser(this.users[userIndex].id).then(() => {
                    this.users.splice(userIndex, 1);
                    if (this.currentPage !== AllUsers) {
                        this.changePage(AllUsers);
                    }
                }).catch(() => {
                    this.$toastr.e('Something went wrong');
                });
            },
            changePage(page) {
                if (!page) {
                    this.currentPage = AllUsers;
                } else {
                    this.currentPage = page;
                }
                this.$toastr.removeByType('error');
            },
        },
    };
</script>

<style lang="scss">
    .page__menu-collapsed {
        .users__header__title {
            padding-left: 81px !important;
        }
    }
</style>
<style
    scoped
    lang="scss"
>
    @import "../scss/base/colors";
    @import "../scss/base/shadow";

    .users {
        color: $dark-blue-color;

        &__page {
            padding: 26px 30px 20px 30px;
            display: flex;
            flex-direction: column;
        }
    }
</style>
